<mat-slide-toggle [checked]="selected" (change)="toggle()">
  {{ (label || placeholder) | translate }}
</mat-slide-toggle>
